<payarc-dialog-shell title="Update Bank Account Request" (closed)="closeAction()">
  <form [formGroup]="changeRequestForm" class="crd-grid">
    <payarc-form-field label="Legal Name" [required]="true" controlId="crdLegalName"
      [error]="changeRequestForm.controls['legal_name'].touched && changeRequestForm.controls['legal_name'].errors?.required ? 'Please make sure the Legal Name is added in your merchant profile in the admin portal.' : ''">
      <input class="pa-input" id="crdLegalName" formControlName="legal_name" type="text" readonly>
    </payarc-form-field>

    <payarc-form-field label="EIN" [required]="true" controlId="crdEin"
      [error]="changeRequestForm.controls['ein'].touched && changeRequestForm.controls['ein'].errors?.required ? 'Please make sure the EIN number is added in your merchant profile in the admin portal.' : ''">
      <input class="pa-input" id="crdEin" [value]="formattedEin" type="text" readonly>
    </payarc-form-field>

    <payarc-form-field label="Routing Number" [required]="true" controlId="crdRoutingNumber"
      [error]="changeRequestForm.controls['routing_number'].touched ? (changeRequestForm.controls['routing_number'].errors?.required ? 'Routing number is required' : changeRequestForm.controls['routing_number'].errors?.routingNumberInvalid ? 'Routing number must be 9 digits and valid' : '') : ''">
      <input class="pa-input" id="crdRoutingNumber" formControlName="routing_number">
    </payarc-form-field>

    <payarc-form-field label="Bank Account" [required]="true" controlId="crdBankAccount"
      hint="The new account must be owned by the Legal Name and have the EIN as the Tax ID for the account"
      [error]="changeRequestForm.controls['bank_account_number'].touched ? (changeRequestForm.controls['bank_account_number'].errors?.required ? 'Bank account number is required' : changeRequestForm.controls['bank_account_number'].errors?.minlength ? 'Bank account number must be at least 4 digits' : changeRequestForm.controls['bank_account_number'].errors?.maxlength ? 'Bank account number must be at most 17 digits' : changeRequestForm.controls['bank_account_number'].errors?.pattern ? 'Bank account number must be numeric only' : '') : ''">
      <input class="pa-input" id="crdBankAccount" formControlName="bank_account_number">
    </payarc-form-field>

    <payarc-form-field label="Type of Account" [required]="true" controlId="crdAccountType"
      [error]="changeRequestForm.controls['type_of_account'].touched && changeRequestForm.controls['type_of_account'].errors ? 'Account type is required' : ''">
      <select class="pa-input" id="crdAccountType" formControlName="type_of_account">
        <option value="" selected>Select account type</option>
        <option value="deposits">Deposits</option>
        <option value="fees">Fees</option>
        <option value="both">Both</option>
      </select>
    </payarc-form-field>
  </form>

  <div footer class="crd-footer">
    <button type="button" payarcButton="secondary" (click)="closeAction()">Cancel</button>
    <app-loading-button [buttonText]="'Save'" [loadFlag]="loadFlag" (buttonClick)="saveChanges()"></app-loading-button>
  </div>
</payarc-dialog-shell>
